import React from 'react';

const NavBar = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Split navigation items for mobile two-row layout
  const topRowItems = [
    { id: 'about', label: 'About', onClick: () => scrollToSection('about') },
    { id: 'EPIC', label: 'EPIC', isTitle: true, onClick: scrollToTop },
    { id: 'cast', label: 'Cast', onClick: () => scrollToSection('cast-page') },
  ];

  const bottomRowItems = [
    { id: 'socials', label: 'Socials', onClick: () => scrollToSection('socials') },
    { id: 'community', label: 'Community', onClick: () => scrollToSection('community') }
  ];

  // All items for desktop layout
  const allItems = [
    { id: 'about', label: 'About', onClick: () => scrollToSection('about') },
    { id: 'socials', label: 'Socials', onClick: () => scrollToSection('socials') },
    { id: 'EPIC', label: 'EPIC', isTitle: true, onClick: scrollToTop },
    { id: 'cast', label: 'Cast', onClick: () => scrollToSection('cast-page') },
    { id: 'community', label: 'Community', onClick: () => scrollToSection('community') }
  ];

  return (
    <nav className="w-full md:fixed md:top-0 md:left-0 md:right-0 z-50 border-b border-red-900/20 bg-black/90 backdrop-blur-sm">
      {/* Mobile Layout - Two Rows */}
      <div className="md:hidden">
        {/* Top Row */}
        <div className="flex justify-center items-center gap-6 px-4 py-2 border-b border-red-900/10">
          {topRowItems.map(item => (
            <button
              key={item.id}
              onClick={item.onClick}
              className={`tracking-wider uppercase text-xs font-mono transition-colors duration-300
                ${item.isTitle 
                  ? 'text-white font-bold text-base px-4' 
                  : 'text-red-500 hover:text-red-400'}`}
            >
              {item.label}
            </button>
          ))}
        </div>
        {/* Bottom Row */}
        <div className="flex justify-center items-center gap-6 px-4 py-2">
          {bottomRowItems.map(item => (
            <button
              key={item.id}
              onClick={item.onClick}
              className="tracking-wider uppercase text-xs font-mono text-red-500 hover:text-red-400 transition-colors duration-300"
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      {/* Desktop Layout - Single Row */}
      <div className="hidden md:block px-4 py-3">
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-center items-center gap-12">
            {allItems.map(item => (
              <button
                key={item.id}
                onClick={item.onClick}
                className={`tracking-wider uppercase text-sm font-mono transition-colors duration-300
                  ${item.isTitle 
                    ? 'text-white font-bold text-xl px-8 cursor-pointer' 
                    : 'text-red-500 hover:text-red-400'}`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;